<script setup>
import { computed } from 'vue';

const props = defineProps({
  isChecked: {
    type: Boolean,
    default: false,
  },
  value: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['update']);

const checked = computed({
  get: () => props.isChecked,
  set: value => emit('update', props.value, value),
});
</script>

<template>
  <input
  v-model="checked"
  :value="value"
  type="checkbox"
  class="flex-shrink-0 mt-0.5 border-ash-200 bg-white checked:border checked:border-green-500 shadow-sm appearance-none rounded-[4px] w-4 h-4 focus:ring-1
    after:content-[''] checked:after:content-['✓']
    after:flex after:items-center after:justify-center after:text-center after:text-xs after:font-bold after:relative
    checked:after:text-green-500" 
  />
</template>
